import React, { Component } from 'react';
import I18n from '~/utils/translations';

export default class ViewingCancelledConfirmation extends Component {
  render() {
    return (
      <div className="viewings__viewing-booked">
        <div className="viewing-cancelled-confirmation__inner-container">
          <h3 className="viewing-cancelled-confirmation__title">{this.confirmationCopy}</h3>
          <h2 className="viewing-cancelled-confirmation__address">{this.props.property.fullAddress}</h2>
          <p className="viewing-cancelled-confirmation__time">{this.props.viewingCancelledPreviousTime}</p>
        </div>
      </div>
    );
  }

  get confirmationCopy() {
    return this.props.property.requestViewingEnabled
      ? I18n.t('viewings.cancel_viewing.request_confirmation')
      : I18n.t('viewings.cancel_viewing.confirmation');
  }
}
